/**
 * DEV-1992 (эпик DEV-1980). Раздел «Задачи»: канбан, список, фильтры.
 *
 * Отдельным словарём, а не в ru.ts: раздел новый и целиком свой, а базовые
 * локали и без того на три тысячи строк. Форма задачи живёт в taskForm.ts,
 * справочник типов — в taskTypes.ts: борда их не переопределяет, только
 * показывает.
 */
export const tasksBoardMessages = {
  ru: {
    common: {
      navigation: {
        tasks: 'Задачи',
      },
    },
    tasks: {
      board: {
        title: 'Задачи',
        subtitle: 'Открыто {open} · просрочено {overdue}',
        views: {
          aria: 'Вид задач',
          board: 'Канбан',
          list: 'Список',
        },
        scope: {
          aria: 'Чьи задачи',
          managers: 'Менеджерские',
          agents: 'Агентские',
        },
        status: {
          todo: 'К выполнению',
          inProgress: 'В работе',
          done: 'Готово',
        },
        moved: 'Задача перенесена: {status}',
        moveError: 'Не удалось перенести задачу',
        entity: {
          deal: 'Сделка',
          client: 'Клиент',
          agent: 'Агент',
        },
        noAssignee: 'Без исполнителя',
        noDue: 'Без срока',
        noType: 'Без типа',
        noEntity: 'Без привязки',
        empty: {
          title: 'Задач пока нет',
          description: 'Задачи заводятся в карточке сделки или клиента.',
          agentsDescription: 'Задачи агентов заводятся сами при регистрации и в карточке агента.',
        },
        emptyFiltered: {
          title: 'Под фильтр ничего не попало',
          description: 'Смените пресет или снимите фильтры.',
        },
        truncated: 'Показано {shown} из {total} — уточните фильтры',
        loadError: 'Не удалось загрузить задачи',
      },
      filters: {
        presets: {
          overdue: 'Просрочены',
          dueToday: 'Срок сегодня',
          dueWeek: 'Срок на этой неделе',
          dueMonth: 'Срок в этом месяце',
          createdToday: 'Создано сегодня',
          createdWeek: 'Создано за неделю',
          createdMonth: 'Создано за месяц',
          closedToday: 'Закрыто сегодня',
          closedWeek: 'Закрыто за неделю',
          closedMonth: 'Закрыто за месяц',
        },
        assignees: 'Исполнители',
        authors: 'Авторы',
        types: 'Типы',
        due: 'Срок',
        selected: 'выбрано: {count}',
        empty: 'Список пуст',
        reset: 'Сбросить',
        toggle: 'Фильтры',
      },
      list: {
        columns: {
          task: 'Задача',
          type: 'Тип',
          entity: 'Сделка / Клиент',
          author: 'Автор',
          assignee: 'Исполнитель',
          created: 'Создана',
          due: 'Срок',
          completed: 'Закрыта',
          status: 'Статус',
          priority: 'Приоритет',
        },
        groupBy: {
          label: 'Группировка',
          none: 'Без группировки',
          type: 'По типу',
          status: 'По статусу',
          assignee: 'По исполнителю',
          due: 'По сроку',
        },
        sortLabel: 'Сортировка',
        sortAsc: 'по возрастанию',
        sortDesc: 'по убыванию',
      },
    },
  },
  en: {
    common: {
      navigation: {
        tasks: 'Tasks',
      },
    },
    tasks: {
      board: {
        title: 'Tasks',
        subtitle: 'Open {open} · overdue {overdue}',
        views: {
          aria: 'Tasks view',
          board: 'Board',
          list: 'List',
        },
        scope: {
          aria: 'Whose tasks',
          managers: 'Manager tasks',
          agents: 'Agent tasks',
        },
        status: {
          todo: 'To do',
          inProgress: 'In progress',
          done: 'Done',
        },
        moved: 'Task moved: {status}',
        moveError: 'Failed to move the task',
        entity: {
          deal: 'Deal',
          client: 'Client',
          agent: 'Agent',
        },
        noAssignee: 'No assignee',
        noDue: 'No due date',
        noType: 'No type',
        noEntity: 'Not linked',
        empty: {
          title: 'No tasks yet',
          description: 'Tasks are created from a deal or client card.',
          agentsDescription: 'Agent tasks are created on sign-up and from the agent card.',
        },
        emptyFiltered: {
          title: 'Nothing matches the filter',
          description: 'Change the preset or clear the filters.',
        },
        truncated: 'Showing {shown} of {total} — narrow the filters',
        loadError: 'Failed to load tasks',
      },
      filters: {
        presets: {
          overdue: 'Overdue',
          dueToday: 'Due today',
          dueWeek: 'Due this week',
          dueMonth: 'Due this month',
          createdToday: 'Created today',
          createdWeek: 'Created this week',
          createdMonth: 'Created this month',
          closedToday: 'Closed today',
          closedWeek: 'Closed this week',
          closedMonth: 'Closed this month',
        },
        assignees: 'Assignees',
        authors: 'Authors',
        types: 'Types',
        due: 'Due date',
        selected: 'selected: {count}',
        empty: 'Nothing to choose',
        reset: 'Reset',
        toggle: 'Filters',
      },
      list: {
        columns: {
          task: 'Task',
          type: 'Type',
          entity: 'Deal / Client',
          author: 'Author',
          assignee: 'Assignee',
          created: 'Created',
          due: 'Due',
          completed: 'Closed',
          status: 'Status',
          priority: 'Priority',
        },
        groupBy: {
          label: 'Group by',
          none: 'No grouping',
          type: 'By type',
          status: 'By status',
          assignee: 'By assignee',
          due: 'By due date',
        },
        sortLabel: 'Sort by',
        sortAsc: 'ascending',
        sortDesc: 'descending',
      },
    },
  },
  vn: {
    common: {
      navigation: {
        tasks: 'Nhiệm vụ',
      },
    },
    tasks: {
      board: {
        title: 'Nhiệm vụ',
        subtitle: 'Đang mở {open} · quá hạn {overdue}',
        views: {
          aria: 'Chế độ xem nhiệm vụ',
          board: 'Bảng',
          list: 'Danh sách',
        },
        scope: {
          aria: 'Nhiệm vụ của ai',
          managers: 'Của quản lý',
          agents: 'Của đại lý',
        },
        status: {
          todo: 'Cần làm',
          inProgress: 'Đang làm',
          done: 'Hoàn thành',
        },
        moved: 'Đã chuyển nhiệm vụ: {status}',
        moveError: 'Không chuyển được nhiệm vụ',
        entity: {
          deal: 'Giao dịch',
          client: 'Khách hàng',
          agent: 'Đại lý',
        },
        noAssignee: 'Chưa có người thực hiện',
        noDue: 'Không có hạn',
        noType: 'Không có loại',
        noEntity: 'Không liên kết',
        empty: {
          title: 'Chưa có nhiệm vụ',
          description: 'Nhiệm vụ được tạo từ thẻ giao dịch hoặc khách hàng.',
          agentsDescription: 'Nhiệm vụ của đại lý được tạo khi đăng ký và từ thẻ đại lý.',
        },
        emptyFiltered: {
          title: 'Không có kết quả phù hợp',
          description: 'Hãy đổi bộ lọc nhanh hoặc xoá bộ lọc.',
        },
        truncated: 'Hiển thị {shown} trong {total} — hãy thu hẹp bộ lọc',
        loadError: 'Không tải được nhiệm vụ',
      },
      filters: {
        presets: {
          overdue: 'Quá hạn',
          dueToday: 'Hạn hôm nay',
          dueWeek: 'Hạn trong tuần này',
          dueMonth: 'Hạn trong tháng này',
          createdToday: 'Tạo hôm nay',
          createdWeek: 'Tạo trong tuần',
          createdMonth: 'Tạo trong tháng',
          closedToday: 'Đóng hôm nay',
          closedWeek: 'Đóng trong tuần',
          closedMonth: 'Đóng trong tháng',
        },
        assignees: 'Người thực hiện',
        authors: 'Người tạo',
        types: 'Loại',
        due: 'Hạn',
        selected: 'đã chọn: {count}',
        empty: 'Danh sách trống',
        reset: 'Đặt lại',
        toggle: 'Bộ lọc',
      },
      list: {
        columns: {
          task: 'Nhiệm vụ',
          type: 'Loại',
          entity: 'Giao dịch / Khách hàng',
          author: 'Người tạo',
          assignee: 'Người thực hiện',
          created: 'Ngày tạo',
          due: 'Hạn',
          completed: 'Ngày đóng',
          status: 'Trạng thái',
          priority: 'Độ ưu tiên',
        },
        groupBy: {
          label: 'Nhóm theo',
          none: 'Không nhóm',
          type: 'Theo loại',
          status: 'Theo trạng thái',
          assignee: 'Theo người thực hiện',
          due: 'Theo hạn',
        },
        sortLabel: 'Sắp xếp',
        sortAsc: 'tăng dần',
        sortDesc: 'giảm dần',
      },
    },
  },
}
